import { render, staticRenderFns } from "./Paywall.vue?vue&type=template&id=00e4eb85&scoped=true"
import script from "./Paywall.vue?vue&type=script&lang=js"
export * from "./Paywall.vue?vue&type=script&lang=js"
import style0 from "./Paywall.vue?vue&type=style&index=0&id=00e4eb85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e4eb85",
  null
  
)

export default component.exports